<template>
  <el-button
    :class="['t-button', `t-button--${variant}`]"
    :type="elType"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :icon="icon"
    :round="round"
    :circle="circle"
    @click="handleClick"
  >
    <slot></slot>
  </el-button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'text' | 'ghost';
  size?: 'large' | 'default' | 'small';
  disabled?: boolean;
  loading?: boolean;
  icon?: any;
  round?: boolean;
  circle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'default',
  disabled: false,
  loading: false,
  round: false,
  circle: false,
});

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();

const elType = computed(() => {
  const typeMap: Record<string, string> = {
    primary: 'primary',
    secondary: 'default',
    success: 'success',
    warning: 'warning',
    danger: 'danger',
    info: 'info',
    text: 'text',
    ghost: 'default',
  };
  return (typeMap[props.variant] || 'primary') as any;
});

const handleClick = (event: MouseEvent) => {
  if (!props.disabled && !props.loading) {
    emit('click', event);
  }
};
</script>

<style scoped>
.t-button {
  /* 继承 Element Plus 样式，通过 element-overrides.css 统一控制 */
}
</style>
